import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Typography from '@ntuctech/devex-tangram/Typography';
import Avatar from '@ntuctech/devex-tangram/Avatar';
import { withForwardedRef } from '../utils/helpers/reactHelpers';
import { ICONS_ALL } from '../utils/icon-group';
const ListItemChild = styled.div `
  width: 100%;
  flex: 1 1 auto;
  min-width: 0;
  margin-left: ${(props) => props.theme.SizeMarginListSmall};
  margin-right: ${(props) => !props.toShowRemoveIcon ? 0 : props.theme.SizeMarginListMedium};
  display: flex;
  flex-direction: column;

  & span {
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${(props) => props.theme.ColorFontListBase};
  }

  & span:nth-child(2) {
    color: ${(props) => props.theme.ColorFontListGrey};
  }
`;
const ListItemSC = styled.div `
  width: 100%;
  position: relative;
  justify-content: flex-start;
  align-items: center;
  display: flex;
  cursor: pointer;
  padding-right: ${(props) => !props.toShowRemoveIcon
    ? props.theme.SizePaddingListBase
    : props.theme.SizePaddingListSmall};
  padding-left: ${(props) => props.theme.SizePaddingListMedium};

  & div[title]:last-child {
    display: none;
  }

  & .removeIcon {
    width: ${(props) => props.theme.SizeWidthListIconBase};
    height: ${(props) => props.theme.SizeHeightListIconBase};
  }

  &:hover {
    background-color: ${(props) => props.theme.ColorBackgroundListHover};
  }

  &:active {
    background-color: ${(props) => props.theme.ColorBackgroundListActive};
  }
`;
const SearchQueryListItem = (props) => {
    const { image, title, subTitle1, subTitle2, subTitle3, imageShape, variant, icon, iconRemove, iconColor, toShowRemoveIcon, iconBgColor, onClickLabel, onClickRemove } = props;
    const handleClickOnlabel = () => {
        onClickLabel();
    };
    const handleClickOnRemove = (event) => {
        event.stopPropagation();
        onClickRemove();
    };
    const subheadings = [subTitle1, subTitle2, subTitle3].filter((item) => item);
    const generateSubheadings = () => {
        const generateText = subheadings
            .map((item) => {
            return `${item} \u00A0·\u00A0 `;
        })
            .join('');
        const removeLastDot = generateText.slice(0, generateText.length - 4);
        return removeLastDot;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ListItemSC, { toShowRemoveIcon: toShowRemoveIcon, onClick: handleClickOnlabel, "data-testid": "list-item" },
            variant === 'image' && image && (React.createElement(React.Fragment, null,
                React.createElement(Avatar, { size: "s", image: image, variant: variant, avatarBgColor: iconBgColor, shape: imageShape }),
                React.createElement(ListItemChild, { toShowRemoveIcon: toShowRemoveIcon },
                    React.createElement(Typography, { as: "span", variant: "body2" }, title),
                    React.createElement(Typography, { as: "span", variant: "body4" }, generateSubheadings())))),
            (variant === 'icon' || !image) && (React.createElement(React.Fragment, null,
                React.createElement(Avatar, { variant: "icon", size: "s", iconColor: iconColor, iconType: icon, avatarBgColor: iconBgColor }),
                React.createElement(ListItemChild, { toShowRemoveIcon: toShowRemoveIcon },
                    React.createElement(Typography, { as: "span", variant: "body2" }, title),
                    React.createElement(Typography, { as: "span", variant: "body4" }, generateSubheadings())))),
            toShowRemoveIcon && (React.createElement(Avatar, { shape: "square", className: "removeIcon", size: "s", variant: "icon", avatarBgColor: iconBgColor, iconColor: iconColor, iconType: iconRemove, onClick: handleClickOnRemove, title: "remove-item" })))));
};
SearchQueryListItem.propTypes = {
    image: PropTypes.string,
    title: PropTypes.element,
    subTitle1: PropTypes.string,
    subTitle2: PropTypes.string,
    subTitle3: PropTypes.string,
    imageShape: PropTypes.oneOf(['round', 'square']),
    variant: PropTypes.oneOf(['image', 'icon']),
    icon: PropTypes.oneOf(ICONS_ALL),
    iconRemove: PropTypes.oneOf(ICONS_ALL),
    iconColor: PropTypes.string,
    iconBgColor: PropTypes.string,
    toShowRemoveIcon: PropTypes.bool,
    onClickLabel: PropTypes.func,
    onClickRemove: PropTypes.func
};
SearchQueryListItem.defaultProps = {
    image: '',
    title: null,
    subTitle1: '',
    subTitle2: '',
    subTitle3: '',
    imageShape: 'round',
    variant: 'image',
    icon: 'SvgHistory',
    iconRemove: 'SvgClose',
    iconColor: '#666666',
    iconBgColor: 'transparent',
    toShowRemoveIcon: true,
    onClickLabel: null,
    onClickRemove: null
};
export { SearchQueryListItem as SearchQueryListItemRootComp };
export default withForwardedRef(SearchQueryListItem);
//# sourceMappingURL=SearchQueryListItem.js.map